import { LocalizationService } from './localization/localization.service';
import { Routes } from '@angular/router';
import { LoginGuard } from './auth/login.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ManagerComponent } from './pages/manager/manager.component';

export const appRoutePath = { dashboard: 'dashboard', manager: 'manager', assets: 'assets', profile: 'profile' };

export const routes: Routes = [
    {
        path: '',
        canActivate: [LoginGuard],
        loadComponent: () => import('./main-page/main-page.component').then((m) => m.MainPageComponent),
        children: [
            {
                path: '',
                redirectTo: appRoutePath.dashboard,
                pathMatch: 'full',
            },
            {
                path: appRoutePath.dashboard,
                loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
            },
            {
                path: appRoutePath.manager,
                loadComponent: () => import('./pages/manager/manager.component').then((m) => m.ManagerComponent),
            },
            {
                path: appRoutePath.assets,
                children: [
                    {
                        path: ':featureUUID',
                        loadComponent: () => import('./pages/asset-list/asset-list.component').then((m) => m.AssetListComponent),
                    },
                ],
            },
            {
                path: appRoutePath.profile,
                loadComponent: () => import('./pages/profile/profile.component').then((m) => m.ProfileComponent),
            },
        ],
    },
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component').then((x) => x.LoginComponent),
    },
];
